import Tab from '../components/tab'

export default {
  Tab
}



// WEBPACK FOOTER //
// ./src/app/professional/record/specialities/resources/components.js